import { DataHelper } from 'tiime-expert-utils';

import { ArithmeticHelper } from '@helpers/arithmetic.helper';
import { DateHelper } from '@helpers/date.helper';
import { AccountInterestLine, AccountInterestLineJson } from '@models/account-interest-line';
import { User, UserJson } from '@models/user';

export interface AccountInterestJson {
  id: number;
  validated: boolean;
  validated_at: string | null;
  validated_by: Partial<UserJson> | null;
  max_rate: number | null;
  account_interest_lines: AccountInterestLineJson[];
}

export type SerializedAccountInterestJson = Pick<
  AccountInterestJson,
  'id' | 'validated' | 'max_rate' | 'account_interest_lines'
>;

export class AccountInterest {
  constructor(
    public id: number,
    public validated: boolean,
    public validatedAt: Date | null,
    public validatedBy: Partial<User> | null,
    public maxRate: number | null,
    public accountInterestLines: AccountInterestLine[]
  ) {}

  static fromJson(json: AccountInterestJson): AccountInterest {
    return new AccountInterest(
      json.id,
      json.validated,
      json.validated_at ? DateHelper.fromUtc(json.validated_at) : null,
      json.validated_by ? User.fromJson(json.validated_by) : null,
      !DataHelper.isNullish(json.max_rate) ? ArithmeticHelper.mul(json.max_rate, 100) : null,
      (json.account_interest_lines ?? []).map(AccountInterestLine.fromJson)
    );
  }

  static toJson(data: AccountInterest): SerializedAccountInterestJson {
    return {
      id: data.id,
      validated: data.validated,
      max_rate: !DataHelper.isNullish(data.maxRate)
        ? ArithmeticHelper.div(ArithmeticHelper.toFloat(data.maxRate), ArithmeticHelper.toFloat(100), 4)
        : null,
      account_interest_lines: data.accountInterestLines.map(AccountInterestLine.toJson)
    };
  }
}
